import {
  documentTableItem,
  ISynopsisObject,
  sentenceItem
} from '../../../lib/models/interfaces';
import { ExpandableCard } from './ExpandableCard';

interface SynopsisProps {
  sentenceMap: {
    [key: string]: sentenceItem;
  };
  synopsisObject: ISynopsisObject;
  handleSentenceClick: (id: string, type: string, label?: string) => void;
  currentDocuments: documentTableItem[];
  setShowSynopsis: (arg: boolean) => void;
}

export const DocumentSynopsis: React.FC<SynopsisProps> = ({
  sentenceMap,
  synopsisObject,
  handleSentenceClick,
  currentDocuments,
  setShowSynopsis
}) => {
  const getDocName = (id: string) => {
    return currentDocuments.filter((ele) => ele._id === id)[0].documentFileName;
  };
  // this is for Topics
  const createPageListing = (ele: string) => {
    return (
      <ExpandableCard
        heading={ele}
        className="mb-1 bg-[#56dac5]/50 hover:bg-[#56dac5] border"
      >
        <div
          className="max-h-[25vh] overflow-y-scroll"
          style={{ scrollbarWidth: 'none' }}
        >
          {Array.from(synopsisObject['domains'][ele]).map((s, idx) => {
            const prevDocId =
              idx > 0
                ? synopsisObject['domains'][ele][idx - 1].documentId
                : null;
            const isNewDoc = s.documentId !== prevDocId;
            const prevPageNo =
              idx > 0 && !isNewDoc
                ? synopsisObject['domains'][ele][idx - 1].PageNumber
                : null;
            const isNewPageNo = s.PageNumber !== prevPageNo;

            return (
              <>
                {isNewDoc && currentDocuments.length > 1 && (
                  <p className="text-lg font-bold">
                    {getDocName(s.documentId)}
                  </p>
                )}
                {isNewPageNo && (
                  <div>
                    {<span>&#8226;</span>}
                    <span
                      className="p-2 hover:cursor-pointer text-md"
                      onClick={() =>
                        handleSentenceClick(s?._id!, 'domain', ele)
                      }
                    >
                      {`Page: ${s.PageNumber}`}
                    </span>
                  </div>
                )}
              </>
            );
          })}
        </div>
      </ExpandableCard>
    );
  };
  return (
    <div className="flex flex-col">
      <div className="flex flex-col w-full items-center relative"></div>
      <div className="pt-4 gap-4">
        <section
          className={
            'w-full rounded-2xl border bg-[#56dac5]  border-zinc-200 shadow-sm backdrop-blur-sm mb-2'
          }
        >
          <div className="flex items-center gap-3 justify-center h-[50px]">
            {/* Accent dot */}

            <div className="text-base sm:text-lg font-semibold text-zinc-900">
              Key Obligations & Tasks
            </div>
          </div>
        </section>
        {synopsisObject['sentences'] &&
          Object.keys(synopsisObject['sentences']).length > 0 &&
          Object.keys(synopsisObject['sentences']).map((ele) => {
            // console.log('ele in sentence map ', ele);
            // element is the activity
            return (
              <>
                <ExpandableCard
                  heading={ele}
                  className="mb-1 bg-[#56dac5]/50 hover:bg-[#56dac5] border"
                >
                  <div
                    className="max-h-[25vh] overflow-y-scroll"
                    style={{ scrollbarWidth: 'none' }}
                  >
                    {synopsisObject['sentences'][ele].map((s, idx) => {
                      const prevDocId =
                        idx > 0
                          ? synopsisObject['sentences'][ele][idx - 1].documentId
                          : null;
                      const isNewDoc = s.documentId !== prevDocId;
                      const isObligation = s?.activities?.filter(
                        (act) => act.label === ele
                      )[0].obligation;
                      return (
                        <>
                          {isNewDoc && (
                            <p className="text-md font-bold italic underline ">
                              {getDocName(s.documentId)}
                            </p>
                          )}
                          <div className="flex align-center">
                            {<p className="text-xl pt-1">&#8226;</p>}
                            <p
                              className={`p-2 hover:cursor-pointer ${isObligation ? 'text-red-800' : 'text-black'}`}
                              onClick={() =>
                                handleSentenceClick(s._id, 'sentence')
                              }
                            >
                              {s.text}
                            </p>
                          </div>
                        </>
                      );
                    })}
                  </div>
                </ExpandableCard>
              </>
            );
          })}
        {/* this is the Topics header */}
        <section
          className={
            'w-full rounded-2xl border bg-[#56dac5] shadow-sm backdrop-blur-sm mb-2 mt-4'
          }
        >
          <div className="flex items-center gap-3 justify-center h-[50px]">
            {/* Accent dot */}

            <div className="text-base sm:text-lg font-semibold text-zinc-900 ">
              Topics
            </div>
          </div>
        </section>
        {synopsisObject['domains'] &&
          Object.keys(synopsisObject['domains']).length > 0 &&
          Object.keys(synopsisObject['domains']).map((ele) => {
            return <>{createPageListing(ele)}</>;
          })}
      </div>
    </div>
  );
};
